import { toArray } from 'lodash'
import { mapLanguage } from 'Lib/i18nMiddleware'
import { SET_LANGUAGE } from './config'

export const PAGES_FETCH_LIST_REQUEST = 'PAGES::FETCH_LIST_REQUEST'
export const PAGES_FETCH_LIST_FAIL = 'PAGES::FETCH_LIST_FAIL'
export const PAGES_FETCH_LIST_SUCCESS = 'PAGES::FETCH_LIST_SUCCESS'
export const PAGES_SET_LIST = 'PAGES::SET_LIST'

const initialState = { list: [], default: [], fetching: false }

export const fetchPageList = () => ({
  type: PAGES_FETCH_LIST_REQUEST,
})

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PAGES_FETCH_LIST_REQUEST: {
      return {
        ...state,
        fetching: true,
      }
    }
    case PAGES_FETCH_LIST_SUCCESS: {
      return {
        ...state,
        list: toArray(action.data).map(mapLanguage(action.lang)),
        default: toArray(action.data),
        fetching: false,
      }
    }
    case PAGES_FETCH_LIST_FAIL: {
      return {
        ...state,
        list: [],
        fetching: false,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        list: state.default.map(mapLanguage(action.payload.lang)),
      }
    }
    default:
      return state
  }
}

export default reducer
